import BoxMessage from "shared/components/box/BoxMessage.js";
import ItemRowPlayerAssist from "shared/components/items/ItemRowPlayerAssist.js";
import { getCalculatedOverall } from "shared/utils/player.js";
import React, { useState } from "react";
import Popup from "reactjs-popup";

interface PopupSelectPlayerProps {
  trigger: Object;
  onClose: func;
  onConfirm: func;
  teamMembers: Object;
  actualPosition?: string;
}

const PopupSelectPlayer: React.FC<PopupSelectPlayerProps> = ({ trigger, onClose, onConfirm, teamMembers, actualPosition }) => {
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);
  const availableMembers = teamMembers
    ?.filter((member) => member.player && !member.position)
    .map((member) => ({
      member,
      overall: actualPosition ? getCalculatedOverall(member.player, actualPosition) : member.player.overall,
    }))
    .sort((a, b) => b.overall - a.overall)
    .map(({ member }) => member);

  const confirm = (close) => {
    if (onConfirm) {
      onConfirm(selectedTeamMember);
    }

    close();
  };

  return (
    <div className="PopupSelectPlayer">
      <Popup trigger={trigger} modal closeOnDocumentClick={false} onOpen={() => setSelectedTeamMember(null)} onClose={onClose} className={"fade-in popup-xl"}>
        {(close) => (
          <div>
            <div className="d-flex flex-row flex-grow-0 mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">Select team member{actualPosition ? ` — ${actualPosition}` : ""}</h2>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-grow-1 flex-column mb-3 overflow-auto">
              {availableMembers?.length > 0 ? (
                availableMembers
                  .map((p) => (
                    <ItemRowPlayerAssist
                      key={p.id}
                      p={p.player}
                      display="ovr"
                      actualPosition={actualPosition}
                      selectable={true}
                      isSelected={selectedTeamMember && selectedTeamMember.player.id === p.player.id}
                      onSelect={() => setSelectedTeamMember(p)}
                    />
                  ))
              ) : (
                <BoxMessage content={"No team member found"} />
              )}
            </div>

            <div className="d-flex flex-grow-0 flex-row justify-content-end mt-3">
              <div>
                <button
                  className="btn btn-info text-white"
                  disabled={!selectedTeamMember}
                  onClick={() => confirm(close)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupSelectPlayer;
